import styles from "./ReferralView.module.css";
import { Button } from "../Button/Button";
import copy from "copy-to-clipboard";
import { useWeb3React } from "@web3-react/core";
import Label from "../Label/Label";

const baseUrl = "https://bnbminingpirates.com/";

export const ReferralView = ({
   refBonus,
}: {
   refBonus: string;
   totalInvestment: string;
}) => {
   const { account } = useWeb3React();
   function handleClick() {
      if (account) {
         copy(`${baseUrl}?ref=${account}`);
         alert("Your link copied successfully");
      }
   }
   return (
      <div className={`box ${styles.wrap}`}>
         <p>
            There are 4 levels of referral bonus. 5%, 3%, 2%, 2%. Referrals
            Commission will be added as Grog directly to your Glass. Referral
            Commissions will be paid from your downlines for compounding also.
            There are no limits for Direct Referrals
         </p>
         <Label label="Your Referral Bonus Grog" value={refBonus} />
         <div className={styles.tools}>
            <Button bgColor="red" onClick={handleClick}>
               Copy My Link
            </Button>
         </div>
      </div>
   );
};
